

import {Order} from '../../types';
import {productionStatuses} from '../../static_data/productionStatuses';

export function filterUndelivered(orders : Order[]) : Order[] {
    return orders.filter(order => order.productionStatus !== productionStatuses.DELIVERED.key);
}